import CertsTable from 'components/PushCerts/CertsTable.react';
import Field from 'components/Field/Field.react';
import BoxFieldset from 'components/BoxFieldset/BoxFieldset.react';
import FileUpload from 'components/FileUpload/FileUpload.react';
import styles from 'dashboard/Settings/Settings.scss';
import Label from 'components/Label/Label.react';
import Notification from 'components/Notification/Notification.react';

import React from 'react';

export default class PushCerts extends React.Component {
  constructor() {
    super();

    this.state = {
      note: null
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      note: {
        type: 'error',
        message: nextProps.error
      }
    });
  }

  onUpload = (file) => {
    this.props.onUpload({ file, type: "push-apple" });
  }

  render() {
    let renderTable = this.props.uploadPending || (this.props.certs && this.props.certs.length > 0);

    return (
      <BoxFieldset el='settings__push_apple_push_certificates'>
        <div className={styles.settingsBox}>
          {this.props.uploadPending ? null :
            <Field
              labelWidth={60}
              label={<Label text='Certificate file' description='Upload your .p12 certificate file to enable push for iOS and OS X.' />}
              input={<FileUpload disabled={this.props.uploadPending} accept='application/x-pkcs12' onChange={this.onUpload} />}
            />
          }
          {
            renderTable
              ?
              <Field
                labelWidth={60}
                label={<Label text='Uploaded certificates' description='Remember, you can only upload two certificates per bundle.' />}
                input={<CertsTable {...this.props} />} />
              : null
          }
        </div>
        <Notification note={this.state.note} close={true} />
      </BoxFieldset>
    );
  }
}
